<template>
    <div class="fliht-release">
        <div class="content">
            <embed type="application/pdf"
                   :src="getPdfStreamUrl"
                   width="100%" height="100%" alt="pdf"
                   background-color="0xFF525659" top-toolbar-height="56" full-frame=""
                   internalinstanceid="21"
                   title="CHROME">
        </div>
        <p class="title is-size-5"><strong>ATC Route</strong></p>
        <div class="atc-route notification is-black">

        <pre v-if="EFF_Json_Data.poOFP.AtcShortText" style="background-color: black;color: white;font-size: large">{{EFF_Json_Data.poOFP.AtcShortText}}</pre>

    </div>
    </div>
</template>

<script>

    import {loadingMixin} from "../../../../utils/mixins";

    import {mapState /*, mapActions,mapGetters*/} from "vuex";

    import {createUrl} from "../../../../http";
    export default {
        name: "FlightPlaning",
        mixins: [loadingMixin],
        props: ["id", "flight"],
        data() {
            return {
                flightReleaseUrl:createUrl('/EffIpadPreview/GetLastOfpPdf/'),
                    // "https://localhost:44333/api/EffIpadPreview/GetLastOfpPdf/", // createUrl('/EffIpadPreview/GetLastOfpPdf/') , // bu kısmı state olarak al // "https://localhost:44333/api/EffIpadPreview/GetLastOfpPdf/"
                    // "https://localhost:44333/api/EffIpadPreview/GetLastOfpPdf/"
            }
        },
        computed: {
                ...mapState("ipadmain",[/*"FKey1",*/ "selectedFlightItems","EFF_Json_Data","WR_Json_Data","OCCSelfVersions_VS_IPADLastKnownVersions","OCCVers_IPADVers_LastIndex"]),

            getPdfStreamUrl:
            {
                  get()
                  {
                      return this.flightReleaseUrl + this.flight.fKeyForZip + '/'  + this.flight.std+'/'+ this.OCCSelfVersions_VS_IPADLastKnownVersions[this.OCCVers_IPADVers_LastIndex].jlvt+"/"+this.flight.flightArchiveStat;
                  },
                  set()
                  {

                  }
            }
        },

        async created()
        {

        },

        methods : {

        }
    }
</script>

<style scoped>
    .content {
        width: 100%;
        height: 700px;
    }
</style>
